var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("验收单信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showReceiptFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowReceipt()
              }
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.showReceiptFlag ? "隐藏" : "展开"))]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showReceiptFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showReceiptFlag
        ? [
            _c("div", { staticClass: "simple-form flex col-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.receipt.innerNo || "无"))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.receipt.buyerRealComCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.receipt.buyerRealComName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.receipt.sellerRealComName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.receipt.buyerInnerSellerCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-select",
                      {
                        on: { change: _vm.invoiceTypeChange },
                        model: {
                          value: _vm.receipt.invoiceType,
                          callback: function($$v) {
                            _vm.$set(_vm.receipt, "invoiceType", $$v)
                          },
                          expression: "receipt.invoiceType"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "增值税-普通发票", value: 1 }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "增值税-专用发票", value: 2 }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择税率", clearable: "" },
                        on: {
                          change: function($event) {
                            _vm.changeActualAmount()
                          }
                        },
                        model: {
                          value: _vm.receipt.taxRate,
                          callback: function($$v) {
                            _vm.$set(_vm.receipt, "taxRate", $$v)
                          },
                          expression: "receipt.taxRate"
                        }
                      },
                      _vm._l(_vm.fiscalTaxMarkList, function(item) {
                        return _c("el-option", {
                          key: item.rate,
                          attrs: { label: item.rate, value: item.rate }
                        })
                      })
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.receipt.taxOffset ? "是" : "否"))
                  ])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("工单费用信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showFeeItemListFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowFeeItemList()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showFeeItemListFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showFeeItemListFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showFeeItemListFlag
        ? _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  ref: "feeItemTable",
                  attrs: {
                    data: _vm.receipt.feeItemList,
                    border: "",
                    maxHeight: "400",
                    "show-summary": "",
                    "summary-method": _vm.getFeeItemSum
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "feeType",
                      label: "费用类型",
                      align: "center",
                      width: "205"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.workFeeTypeMap[rows.row.feeType])
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "feeName",
                      label: "费用名称",
                      width: "300",
                      align: "left"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "amount",
                      label: "费用金额(元)",
                      align: "right",
                      width: "200"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.amount != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.amount.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "taxRate",
                      label: "税率(%)",
                      align: "right",
                      "render-header": _vm.renderTaxRate
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.taxRate != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.taxRate.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "settleAmount",
                      label: "应结算金额(元)",
                      align: "right",
                      width: "200"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.settleAmount != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(rows.row.settleAmount.toFixed(2))
                                  )
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "settleAmountX",
                      label: "纳入结算金额(元)",
                      align: "right",
                      width: "200"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.settleAmountX != null &&
                            rows.row.settleInvolved
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(rows.row.settleAmountX.toFixed(2))
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "300",
                      prop: "settleInvolved",
                      label: "纳入结算单"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(rows.row.settleInvolved ? "√" : ""))
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.receipt.invalid
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("工单列表")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "shrink-tab fr",
                class: _vm.showWorkVoucherListFlag ? "current" : "",
                on: {
                  click: function($event) {
                    _vm.doShowWorkVoucherList()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.showWorkVoucherListFlag ? "隐藏" : "展开"))
                ]),
                _vm._v(" "),
                _c("i", {
                  class: _vm.showWorkVoucherListFlag
                    ? "el-icon-arrow-down"
                    : "el-icon-arrow-right"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showWorkVoucherListFlag && !_vm.receipt.invalid
        ? _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  ref: "dataTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.receipt.workVoucherList,
                    border: "",
                    maxHeight: "400",
                    "summary-method": _vm.getWorkItemSum,
                    "show-summary": ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "no", label: "工单号", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "servcType",
                      label: "工单类型",
                      width: "100",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.servcTypeMap[rows.row.servcType])
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "devcTitle",
                      width: "180",
                      label: "设备名称",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "devcGroupFullName",
                      label: "维保分组",
                      width: "140",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tmpNo",
                      label: "系统编号",
                      width: "180",
                      align: "center",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "toDoorFee",
                      label: "上门费(元)",
                      width: "100",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.toDoorFee != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.toDoorFee.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "generallFee",
                      label: "服务费(元)",
                      width: "100",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.generallFee != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(rows.row.generallFee.toFixed(2))
                                  )
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "accFee",
                      label: "配件费(元)",
                      width: "100",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.accFee != null
                              ? _c("span", [
                                  _vm._v(_vm._s(rows.row.accFee.toFixed(2)))
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "60",
                      prop: "settleFree",
                      label: "无需结算"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(rows.row.settleFree ? "是" : "否"))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "60",
                      prop: "freeFlag",
                      label: "是否免费"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(rows.row.freeFlag ? "免费" : "收费")
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      width: "100",
                      prop: "violated",
                      label: "是否违约"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.violated && rows.row.violateState == 1
                              ? _c("span", { staticClass: "font-red" }, [
                                  _vm._v("违约（未处理）")
                                ])
                              : rows.row.violated && rows.row.violateState == 0
                              ? _c("span", { staticClass: "font-green" }, [
                                  _vm._v("违约（已处理）")
                                ])
                              : !rows.row.violated
                              ? _c("span", [_vm._v("正常")])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      prop: "violateHandleDesc",
                      label: "违约处理说明",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: "操作",
                      width: "100",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.violated &&
                            rows.row.violateState == 1 &&
                            !rows.row.workReceipConfirmFlag
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.handleViolate(rows.row)
                                      }
                                    }
                                  },
                                  [_vm._v("处理违约")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            rows.row.violated && !rows.row.workReceipConfirmFlag
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.createWorkVoucher(rows.row)
                                      }
                                    }
                                  },
                                  [_vm._v("补发工单")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            rows.row.settleFree
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.setWorkVoucherSettleFree(rows.row)
                                      }
                                    }
                                  },
                                  [_vm._v("需要结算")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !rows.row.settleFree
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.setWorkVoucherSettleFree(rows.row)
                                      }
                                    }
                                  },
                                  [_vm._v("无需结算")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("验收单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("公司编码")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务商公司名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务商标识")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("税率(%)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否抵扣税")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cbd79d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cbd79d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/receipt/ServcWorkReceiptConfirm.vue
// module id = 3017
// module chunks = 0